export default function evolution() {
    const items = document.querySelectorAll(".evolution__item");

    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const bar = entry.target.querySelector(".bar");
                const num = entry.target.querySelector(".increment");

                if (bar && !bar.dataset.animated) {
                // pega o valor de data-number do span, não altera o span
                const percentage = num ? parseInt(num.dataset.number, 10) || 0 : 0;
                    bar.style.width = `${percentage}%`;
                    bar.dataset.animated = "true";
                }

                obs.unobserve(entry.target); // só anima uma vez
            }
        });
    }, { threshold: 0.25 });

    items.forEach(item => observer.observe(item));
}